import { Link } from "react-router-dom";

type BrandWordmarkProps = {
	admin?: boolean;
};

export function BrandWordmark({ admin = false }: BrandWordmarkProps) {
	return (
		<Link
			className={`brand-wordmark${admin ? " brand-wordmark--admin" : ""}`}
			to={admin ? "/admin/operations" : "/"}
		>
			<span>TheLINE</span>
			{admin ? <small>Care</small> : null}
		</Link>
	);
}
